import "./style.scss";

export const CardWrapper = (props) => {
  return <div className="card-wrapper">{props.children}</div>;
};

export const CardWrapperSmall = (props) => {
  return <div className="card-wrapper-small">{props.children}</div>;
};
